<ngx-spinner></ngx-spinner>

<ng-template #modificarFotoVCard let-c="close" let-d="dismiss">
  <div class="modal-header" style="margin-top: -10px; padding: 1rem 1rem 0.5rem 1rem;">
    <h4 class="modal-title" style="font-size: 8pt;">Agrega una imagen para editar</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">

    <!-- <div ng2FileDrop [ngClass]="{'nv-file-over': hasBaseDropZoneOver}" (fileOver)="fileOverBase($event)" *ngIf="!imageChangedEvent"
      [uploader]="uploader" class="py-5 mb-3 text-center font-medium-5 text-uppercase grey my-drop-zone" (change)="fileChangeEvent($event)">
      Arrasta la imagen aqui
    </div> -->

    <div style="text-align: center;" *ngIf="!imageChangedEvent">
      <label class="font-medium-2 text-uppercase">Arrasta la imagen aqui</label>
    </div>

    <div class="file-container" *ngIf="!imageChangedEvent" >
        <input type="file" class="file" (change)="getFile($event)" style="width:100%"/>              
    </div>
    
    <br *ngIf="!imageChangedEvent">

    <div style="text-align: center;" *ngIf="!imageChangedEvent">
      <label class="font-medium-2 text-uppercase">o Selecciona tu archivo</label>
    </div>

    <div class="row" *ngIf="!imageChangedEvent">                             
      <div class="custom-file mx-auto d-block col-md-8">
        <input type="file" class="custom-file-input" id="inputGroupFile01" (change)="fileChangeEvent($event)" accept="image/png, image/gif, image/jpeg">
        <label class="custom-file-label" for="inputGroupFile01">Seleccion tu archivo</label>
      </div>
    </div>

    <div class="row" *ngIf="imageChangedEvent" style="text-align: center;">
      <div class="col-md-12" style="margin-top: 10px;">
        <button type="button" class="btn btn-primary btn-raised" (click)="rotateLeft()" style="margin-left: 5px; width: 160px;">Gira a la izquierda</button>
        <button type="button" class="btn btn-primary btn-raised" (click)="rotateRight()" style="margin-left: 5px; width: 160px;">Gira a la derecha</button>
        <button type="button" class="btn btn-primary btn-raised" (click)="flipHorizontal()" style="margin-left: 5px; width: 160px;">Gira en horizontal</button>
        <button type="button" class="btn btn-primary btn-raised" (click)="flipVertical()" style="margin-left: 5px; width: 160px;">Gira en vertical</button>
        <button type="button" class="btn btn-warning btn-raised" (click)="cancelCropping()" style="margin-left: 5px; width: 180px;">Cancelar Imagen 
          <i class="ft-x position-right"></i>
        </button>    
      </div>
    </div>
    
    <div class="row" *ngIf="imageChangedEvent" style="text-align: center;">
      <div class="col-md-6">
        <div class="form-group">
          <table>
            <tr>
              <td>
                <label class="font-medium-2 text-uppercase">Rotar</label>
              </td>
              <td>
                <input type="number" class="form-control" min="0" max="360" maxlength="3" style="margin-left: 5px; width: 70px"
                    [(ngModel)]="rotation" [ngModelOptions]="{standalone: true}" (ngModelChange)="revisarRotation()">
              </td>
              <td>
                <nouislider [min]="0" [max]="360" [step]="1" [(ngModel)]="rotation" (ngModelChange)="updateRotation()" style="width: 300px; margin-top: 50px; margin-left: 5px;">
                </nouislider>
              </td>              
            </tr>
          </table>          
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <table>
            <tr>
              <td>
                <label class="font-medium-2 text-uppercase">Zoom</label>
              </td>
              <td>
                <input type="number" class="form-control" min="-10" max="10" maxlength="2" style="margin-left: 5px; width: 70px"
                    [(ngModel)]="scale" [ngModelOptions]="{standalone: true}" (ngModelChange)="revisarZoom()">
              </td>           
              <td>
                <nouislider [min]="-10" [max]="10" [step]="0.1" [(ngModel)]="scale" (ngModelChange)="zoomChange()" style="width: 300px; margin-top: 50px; margin-left: 5px;">
                </nouislider>
              </td>              
            </tr>
          </table>          
        </div>
      </div>
    </div>

    <div class="row">                               
      <div class="col-md-6" style="margin-top: 10px; text-align: center;">
        <image-cropper [imageChangedEvent]="imageChangedEvent" 
                        [maintainAspectRatio]="true"
                        [containWithinAspectRatio]="false"
                        [resizeToWidth]="512"
                        [cropperMinWidth]="128"
                        [onlyScaleDown]="true"
                        [canvasRotation]="canvasRotation"
                        [transform]="transform"
                        [alignImage]="'left'"                     
                        format="png" 
                        (imageCropped)="imageCropped($event)" 
                        (imageLoaded)="imageLoaded()"
                        (cropperReady)="cropperReady()" 
                        (loadImageFailed)="loadImageFailed()"                        
                        [style.display]="showCropper ? null : 'none'">
        </image-cropper>
        <!-- <image-cropper
            [imageChangedEvent]="imageChangedEvent"
            [maintainAspectRatio]="true"            
            format="png"
            roundCropper = true
            (imageCropped)="imageCropped($event)"
            (imageLoaded)="imageLoaded()"
            (cropperReady)="cropperReady()"
            (loadImageFailed)="loadImageFailed()"
            class="float-left mr-4 img-fluid col-md-3"
            [style.display]="showCropper ? null : 'none'">
        </image-cropper> -->
      </div>
      <br>
      <div class="col-md-6" style="margin-top: 10px; text-align: center;" *ngIf="showCropper">
        <span class="result">
          <img [src]="croppedImage" style="width: 360px"/>           
        </span>
      </div>
      
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-sm btn-primary btn-raised" style="font-size: 8pt;" (click)="guardarImagen()">Guardar</button>
    <button type="button" class="btn btn-sm btn-warning btn-raised" style="font-size: 8pt;" (click)="cancelarGuardarFoto()">Cancelar</button>
  </div>
</ng-template>

<section id="basic-form-layouts">
    <div class="row text-left">
        <div class="col-md-12 col-lg-12">
            <div class="card">
                <div class="card-content">
                    <div class="card-body">
                        <div class="row text-left match-height justify-content-md-center">
                            <div class="col-md-6" style="margin-right: -20px">
                                <form class="form">
                                    <div class="row">
                                        <div class="col-md-2">
                                            <table>
                                                <tr>
                                                    <td>
                                                        <div class="form-group">
                                                            <label for="imagen" style="font-size: 8pt">Imagen</label>
                                                            <div class="d-flex align-items-center">
                                                                <a href="javascript:;">
                                                                    <img [src]="vcardInfo.photo != null ? vcardInfo.photo : (croppedImage != '' ? croppedImage :  'assets/FotoUserCuadrado.png')"
                                                                        alt="user view avatar"
                                                                        class="users-avatar-shadow rounded" height="64"
                                                                        width="64">
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td style="width: 10px;">
                                                    </td>
                                                    <td>
                                                        <a class="warning" data-toggle="tooltip"
                                                            (click)="editarFotoVCard(modificarFotoVCard)"
                                                            data-placement="top" title="Editar">
                                                            <i class="ft-edit font-medium-3"></i>
                                                        </a>
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                        <div class="col-md-10">
                                            <table>
                                                <tr>
                                                    <td>
                                                        <div class="form-group">
                                                            <label for="Title" style="font-size: 8pt">Titulo *</label>
                                                            <input type="text" id="Title" class="form-control" maxlength="18"
                                                                style="font-size: 8pt; width: 100px" name="Title"
                                                                [(ngModel)]="vcardInfo.title" readonly>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div class="form-group" style="margin-right: 10px; margin-left: -20px;">
                                                            <label for="nombre" style="font-size: 8pt">Nombre(s) *</label>
                                                            <input type="text" id="nombre" class="form-control" name="firstName"
                                                                style="font-size: 8pt" readonly [(ngModel)]="vcardInfo.firstName">
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div class="form-group">
                                                            <label for="apellido" style="font-size: 8pt">Apellido(s) *</label>
                                                            <input type="text" id="apellido" class="form-control"
                                                                style="font-size: 8pt" name="lastName" readonly
                                                                [(ngModel)]="vcardInfo.lastName">
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <div class="form-group" style="margin-right: 10px;">
                                                            <label for="Organization" style="font-size: 8pt">Organización *</label>
                                                            <input type="text" id="Organization" class="form-control" maxlength="18"
                                                                name="Organization" readonly [(ngModel)]="vcardInfo.organization"
                                                                style="font-size: 8pt; width: 130px;">
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div class="form-group">
                                                            <label for="OrganizationPosition" style="font-size: 7pt">Puesto en
                                                                organización *</label>
                                                            <input type="text" id="OrganizationPosition" class="form-control"
                                                                style="font-size: 8pt; width: 150px" name="OrganizationPosition"
                                                                [(ngModel)]="vcardInfo.organizationPosition" readonly>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>